import React from "react";
import "./CodeSnippet.css";

const CodeSnippet = () => {
  return (
    <div className="code-editor">
      <div className="code-header d-flex justify-content-start p-2">
        <span className="circle bg-danger"></span>
        <span className="circle bg-warning"></span>
        <span className="circle bg-success"></span>
      </div>
      <pre className="code-content">
        {`<Stack>
  <JavaScript />
  <Frontend>
    <HTML />
    <CSS />
    <ReactJS />
    <UI DEVELOPMENT />
  </Frontend>
  <Backend>
    <Node.js />
    <Express.js />
  </Backend>
  <TypeScript />
  { ...otherTechnologies }
</Stack>`}
      </pre>
    </div>
  );
};

export default CodeSnippet;
